import React from "react";
import { EmojiDisplay } from "./EmojiDisplay";

export class EmojiDisplayContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            grid: true
        };

        this.select = this.select.bind(this);
        this.toggleGrid = this.toggleGrid.bind(this);
    }

    select() {
        // select on click
        if(this.props.active == 0) {
            // if not selected
            this.props.select(this.props.zIndex - 1);
        }
        else {
            // if selected, select the next one down
            this.props.select(-1);
        }
    }

    toggleGrid() {
        this.setState({ grid: !this.state.grid });
    }


    render() {
        // render emoji
        var layers = [], total = this.props.layers.length;

        this.props.layers.map((item, i) => {
            // check if active
            var active = false;

            if(i == this.props.active) {
                active = true;
            }

            layers.push(
                <EmojiDisplay 
                    section={item.section} 
                    select={this.props.select}
                    icon={item.item} 
                    key={i} index={i} 
                    info={item}
                    zIndex={total - i}
                    active={active}
                />
            );
        });


        return (
            <div className="emoji-display-container" onDoubleClick={this.toggleGrid} id={this.props.id}>
                {(this.state.grid) ? <div className="grid"></div> : ""}

                {layers}
            </div>
        );
    }
}


EmojiDisplayContainer.defaultProps = {
    layers: [],
    id: "",
    side: 128,
    select: () => {}
};
